export const NoPage = (): JSX.Element => {
    return <div>
        <h3>Page not found</h3>
    </div>
}